/* eslint-disable */
import React from 'react';

import css from './ContextSearch.module.scss';

export default function SearchSuggestItem(props) {
  const { item, onItemClick, type } = props;

  // Функция для санитизации текста
  const sanitizeText = text => {
    if (!text || typeof text !== 'string') return text;

    // Удаляем HTML теги и символы с помощью регулярных выражений
    return text
      .replace(/<[^>]*>/g, '') // Удаляем HTML теги
      .replace(/[<>&"']/g, '') // Удаляем опасные HTML символы
      .trim();
  };

  const onClick = () => {
    onItemClick(item, type);
  };

  // Санитизируем отображаемые данные
  const safeName = sanitizeText(item.name);
  const safeType = sanitizeText(item.type);

  return (
    <div className={css['ContextSearch-result-item']} onClick={onClick}>
      <div className={css['ContextSearch-result-blockName-name']}>{safeName}</div>
      <div className={css['ContextSearch-result-blockName-label']}>{safeType}</div>
    </div>
  );
}
